module.exports = __webpack_public_path__ + "img/almode_256x181.e3387910.png";